/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: EBbuUzYSewBk

import * as React from "react";

import {
  Flex as Flex__,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  renderPlasmicSlot,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { BaseTooltip } from "@plasmicpkgs/react-aria/skinny/registerTooltip";
import OverlayArrow from "../../components/plexus/OverlayArrow"; // plasmic-import: FRA2fXjcDHo2/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicTooltip.module.css"; // plasmic-import: EBbuUzYSewBk/css

createPlasmicElementProxy;

export type PlasmicTooltip__VariantMembers = {};
export type PlasmicTooltip__VariantsArgs = {};
type VariantPropType = keyof PlasmicTooltip__VariantsArgs;
export const PlasmicTooltip__VariantProps = new Array<VariantPropType>();

export type PlasmicTooltip__ArgsType = {
  openDelay?: number;
  closeDelay?: number;
  placement?: "top" | "bottom" | "left" | "right";
  isDisabled?: boolean;
  showArrow?: boolean;
  offset?: number;
  triggerAction?: "focus" | "focus and hover";
  trigger?: React.ReactNode;
  content?: React.ReactNode;
};
type ArgPropType = keyof PlasmicTooltip__ArgsType;
export const PlasmicTooltip__ArgProps = new Array<ArgPropType>(
  "openDelay",
  "closeDelay",
  "placement",
  "isDisabled",
  "showArrow",
  "offset",
  "triggerAction",
  "trigger",
  "content"
);

export type PlasmicTooltip__OverridesType = {
  ariaTooltip?: Flex__<typeof BaseTooltip>;
  overlayArrow?: Flex__<typeof OverlayArrow>;
  freeBox?: Flex__<"div">;
};

export interface DefaultTooltipProps {
  openDelay?: number;
  closeDelay?: number;
  placement?: "top" | "bottom" | "left" | "right";
  isDisabled?: boolean;
  showArrow?: boolean;
  offset?: number;
  triggerAction?: "focus" | "focus and hover";
  trigger?: React.ReactNode;
  content?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicTooltip__RenderFunc(props: {
  variants: PlasmicTooltip__VariantsArgs;
  args: PlasmicTooltip__ArgsType;
  overrides: PlasmicTooltip__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          openDelay: 0,
          closeDelay: 0,
          placement: "top",
          showArrow: false,
          offset: 10,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "ariaTooltip.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <BaseTooltip
      data-plasmic-name={"ariaTooltip"}
      data-plasmic-override={overrides.ariaTooltip}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_tXkSR39sgCDWSitZxC5xFV",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.ariaTooltip
      )}
      closeDelay={args.closeDelay}
      defaultOpen={false}
      delay={args.openDelay}
      isDisabled={args.isDisabled}
      isOpen={generateStateValueProp($state, ["ariaTooltip", "isOpen"])}
      offset={args.offset}
      onOpenChange={async (...eventArgs: any) => {
        generateStateOnChangeProp($state, ["ariaTooltip", "isOpen"]).apply(
          null,
          eventArgs
        );
      }}
      placement={args.placement}
      resetClassName={classNames(
        "root_reset_tXkSR39sgCDWSitZxC5xFV",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames
      )}
      tooltipContent={
        <React.Fragment>
          {(() => {
            try {
              return $props.showArrow;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <OverlayArrow
              data-plasmic-name={"overlayArrow"}
              data-plasmic-override={overrides.overlayArrow}
              className={classNames("__wab_instance", sty.overlayArrow)}
              dark={true}
            />
          ) : null}
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames("all", sty.freeBox)}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <React.Fragment>
                  <div
                    className={classNames("all", "__wab_text", sty.text__j1Xqk)}
                  >
                    {"Hello from Tooltip! "}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__oYqcw)}
                  >
                    {"Lorem ipsum dolor sit amet"}
                  </div>
                </React.Fragment>
              ),
              value: args.content,
              className: classNames(sty.slotTargetContent),
            })}
          </div>
        </React.Fragment>
      }
      trigger={args.triggerAction}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <div className={classNames("all", "__wab_text", sty.text___3QQbq)}>
            {"Hover me!"}
          </div>
        ),
        value: args.trigger,
        className: classNames(sty.slotTargetTrigger),
      })}
    </BaseTooltip>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  ariaTooltip: ["ariaTooltip", "overlayArrow", "freeBox"],
  overlayArrow: ["overlayArrow"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  ariaTooltip: typeof BaseTooltip;
  overlayArrow: typeof OverlayArrow;
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTooltip__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTooltip__VariantsArgs;
    args?: PlasmicTooltip__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicTooltip__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTooltip__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTooltip__ArgProps,
          internalVariantPropNames: PlasmicTooltip__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicTooltip__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "ariaTooltip") {
    func.displayName = "PlasmicTooltip";
  } else {
    func.displayName = `PlasmicTooltip.${nodeName}`;
  }
  return func;
}

export const PlasmicTooltip = Object.assign(
  // Top-level PlasmicTooltip renders the root element
  makeNodeComponent("ariaTooltip"),
  {
    // Helper components rendering sub-elements
    overlayArrow: makeNodeComponent("overlayArrow"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicTooltip
    internalVariantProps: PlasmicTooltip__VariantProps,
    internalArgProps: PlasmicTooltip__ArgProps,
  }
);

export default PlasmicTooltip;
/* prettier-ignore-end */
